import React, { type ReactNode } from 'react';

import type { AppConfig, AppConfigParam, Config } from './types';
import { getAppConfig } from './utils/appConfigGenerator';

export const AppConfigContext = React.createContext<Config | undefined>(
  undefined,
);

export const useAppConfig = (): AppConfig => {
  const context = React.useContext(AppConfigContext);
  if (!context) {
    throw new Error('useAppConfig must be used within a ConfigProvider');
  }
  return context.appConfig;
};

export const AppConfigProvider = ({
  param,
  children,
}: {
  param: AppConfigParam;
  children: ReactNode;
}) => {
  const { site, brand, language, locale, zone } = param;
  const appConfig = getAppConfig({
    site,
    zone,
    brand,
    locale,
    language,
  });
  return (
    <AppConfigContext.Provider value={{ appConfig }}>
      {children}
    </AppConfigContext.Provider>
  );
};
